import React from "react";
import { Link } from "react-router-dom";
import tools from "../../../../helpers/tools";
import Table from "../../../common/Table/Table";
import useSubscriptionTemplates from "../../../hooks/useSubscriptionTemplates/useSubscriptionTemplates";

const SubscriptionTemplatesListTable = () => {
  const { isLoading, subscriptionTemplatesSearch, languages, subscriptionTemplates_actions, state } =
    useSubscriptionTemplates();

  return (
    <Table
      isLoading={isLoading}
      nbResults={subscriptionTemplatesSearch.count}
      datas={subscriptionTemplatesSearch.data}
      fields={[
        {
          name: "Nom",
          path: "name",
        },
        {
          name: "Code",
          path: "code",
        },
        {
          name: "Description",
          path: "description",
        },

        {
          name: "Actions",
          path: "*",
          render: (el) => {
            return (
              <>
                <Link className="btn btn-secondary btn-sm me-1" to={`/subscription-templates/${el.id}`}>
                  Ouvrir
                </Link>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => subscriptionTemplates_actions.deleteEntity(el.id)}
                >
                  <i className="fa fa-times  text-white" />
                </button>
              </>
            );
          },
        },
      ]}
    />
  );
};

export default SubscriptionTemplatesListTable;
